import { ChartMenuPens } from '../popups/pens/pens.js';
import { ChartMenuInterval } from '../popups/interval/interval.js';
import { UiMenu } from '../../common/menu/index.js';
import i18next from "i18next";
import styles from './menu.css'

const template = () => `
    <style>
        ${styles}
    </style>
    <div>
        <ui-menu>
            <div class="menu-icon" slot="label"></div>
        </ui-menu>
    </div>
`;

/**
 * @class ChartMenu
 * @classdesc Меню столбчатой диаграммы
 * */
export class ChartMenu {

    constructor(container, root) {
        this.container = container
        this.root = root
        this.state = this.root.state
        this.container.innerHTML = template()
        this.initMenuComponent()
    }

    render() {
        this.menuElem.render()
        this.menuTreeElem = this.menuElem.shadowRoot.querySelector('#tree-list')
        this.menuTreeElem?.addEventListener?.('click', this.onMenuTreeSelect.bind(this))
        this.menuItems = this.menuTreeElem?.children
    }

    initMenuComponent() {
        this.root.checkComponent('ui-menu', UiMenu)
        this.menuElem = this.container.querySelector('ui-menu')
        this.menuElem.cssElem.innerHTML += styles
        this.menuElem.activeElements = this.getMenuActiveElements.bind(this)
        this.menuElem.onSelect = this.onMenuSelect.bind(this)
        this.root.shadowRoot.addEventListener('click', this.autoClose.bind(this))
        this.menuElem.shadowRoot.addEventListener('mouseover', this.hideTooltip.bind(this))
        this.render()
    }

    /**
     * Получить самые свежие данные по меню
     * */
    getMenuActiveElements() {
        const data = [
            { label: `<div class="graph-icon"></div><div>${i18next.t("chartmenu_group_settings")}</div>`, value: 'pens', active: this.root.pmPensSettings ? this.root.setuppengroup : false },
            { label: `<div class="calendar-icon"></div><div>${i18next.t("chartmenu_select_interval")}</div>`, value: 'interval', active: this.root.pmIntervalsSettings ? this.root.setupinterval : false },
            {
                label: `
                <div class="tree">
                    <div class="label">
                        <div>${i18next.t("chartmenu_diagram_view")}</div><span class="icon"/
                    </div>
                    <div class="tree-hover">
                        <ul id="tree-list" class="tree-list">
                            ${(this.root.setupcustomization || this.root.setupdatatype) ? `
                                <li val="scale"><input type="checkbox" ${this.root.autoscaling ? 'checked' : ''} /> <label>${i18next.t("chartmenu_autoscaling")}</label></li>
                                <li val="history"><input type="checkbox" ${this.root.accumulation ? 'checked' : ''} /> <label>${i18next.t("chartmenu_accumulation")}</label></li>
                            ` : ''}
                        </ul>
                    </div>
                </div>
            `, value: 'tree', active: this.root.setupcustomization || this.root.setupdatatype
            },
            { label: `<div class="reset-icon"></div><div>${i18next.t("chartmenu_reset_settings")}</div>`, value: 'clean', active: this.root.resetsetup },
            { label: `<div class="download-icon"></div><div>${i18next.t("chartmenu_save_image")}</div>`, value: 'download', active: this.root.pmImageExport ? this.root.imageexport : false },
            { label: `<div class="print-icon"></div><div>${i18next.t("trend_toolbar_print")}</div>`, value: 'print', active: this.root.pmPrint ? this.root.chartprinting : false },
        ]
        return data.filter(item => item.active)
    }

    onMenuTreeSelect(e) {
        e.stopPropagation()
        const li = e.target.closest('li')
        const value = li.getAttribute('val')
        if (!li || !value) return
        if (value === 'grid') {
            this.root.backgroundgrid = !this.root.backgroundgrid
            this.setTreeValue(this.root.backgroundgrid, 0)
        }
        if (value === 'values') {
            this.root.yaxisactive = !this.root.yaxisactive
            this.setTreeValue(this.root.yaxisactive, 1)
        }
        if (value === 'scale') {
            this.root.autoscaling = !this.root.autoscaling
            this.setTreeValue(this.root.autoscaling, 0)
        }
        if (value === 'history') {
            this.root.accumulation = !this.root.accumulation
            this.setTreeValue(this.root.accumulation, 1)
        }
    }

    /**
     * Срабатывает при выборе элемента меню
     * */
    onMenuSelect(e) {
        const li = e.target.closest('li')
        const value = li?.getAttribute('val')
        if (!li || !value) return
        if (value === 'pens') this.selectPen()
        if (value === 'interval') this.selectInterval()
        if (value === 'clean') this.root.resetSettings()
        if (value === 'download') this.root.downloadImage()
        if (value === 'print') this.root.printChart()
    }

    setTreeValue(value, index) {
        if (!this.menuItems?.[index]) return
        const input = this.menuItems[index].querySelector('input')
        input.checked = value
    }

    updateTreeValues() {
        const values = [this.root.autoscaling, this.root.accumulation]
        for (let i = 0; i < values.length; i++) {
            this.setTreeValue(values[i], i)
        }
    }

    selectPen() {
        if (!this.pensElem) {
            const root = document.createElement('div')
            this.root.shadowRoot.appendChild(root)
            this.pensElem = new ChartMenuPens(root, this)
        }
        this.pensElem.modal.modalComponent.toggle()
    }

    selectInterval() {
        if (!this.intervalElem) {
            const root = document.createElement('div')
            this.intervalElem = new ChartMenuInterval(root, this)
            this.root.shadowRoot.appendChild(root)
        }
        this.intervalElem.modal.modalComponent.toggle()
    }

    autoClose(e) {
        if (!this.menuElem?.opened) return
        const target = e.target
        if (!target.shadowRoot && !this.menuElem.contains(target)) this.menuElem.opened = false
    }

    hideTooltip() {
        this.root.echarts.dispatchAction({ type: 'hideTip' })
    }
}